function showForm() {
  var contactForm = document.getElementById("contact-form");
  var appFormSent = document.getElementById("app-form-sent");
  var appFormErr = document.getElementById("app-form-err");
  contactForm.reset();
  contactForm.style.display = "block";
  appFormSent.style.display = "none";
  appFormErr.style.display = "none";
  // contactForm.scrollIntoView();
}

// scroll to top button
var btn = $('#button-top');

$(window).scroll(function() {
  if ($(window).scrollTop() > 1000) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});



// jQuery
$(document).ready(function () {

  // send e-mail
  $("#contact-form").submit(function (e) {
    e.preventDefault();
    if ($(this).data('submitted') === true) {
        return false;
    } else {
        $(this).data('submitted', true);
        let data = {
            template: 'hr-contact',
            params: {
                name: $('#name').val(),
                surname: $('#surname').val(),
                fromEmail: $('#email').val(),
                phone: $('#phone').val(),
                company: $('#company').val(),
                ico: $('#ico').val(),
                message: $('#msg').val()
            },
            email: {
                from: 'hrshop@asiana.cz',
                fromName: 'Kontaktní formulář - HRshop.cz',
                subject: 'Kontaktní formulář - HRshop.cz',
                address: [ 'sales@letuska.cz' ],
                bcc: [ 'p.pulchart@letuska.cz' ]
            }
        };

        let $form = $(this),
            url = $form.attr('action');

        let http = new XMLHttpRequest();
        http.open('POST', url, true);
        http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        http.send(JSON.stringify(data));

        http.onreadystatechange = function () {
            console.log('http.readyState', http.readyState);
            if (http.readyState === 4 && http.status === 201) {
                console.log('http.status', http.status);
                // scrollTo($('#contact-form').offset().top);
                $('#app-form-sent').css('display', 'block');
                $('#contact-form').css('display', 'none');
            }
            // TODO: error status
        };
        return true;
    }
  });

  // Burger menu
  // --------------------
  let menu = $('#navigation');
  // let outnum = 0;

  $('.burgerMenu')
    .click(function () {
      if (menu.hasClass('menu_open')) {
        menu.removeClass('menu_open');
      } else {
        menu.addClass('menu_open');
        // outnum = 0;
      }
    })

  // Hide menu after click
  // --------------------
  $('#navigation')
    .click(function () {
      if (menu.hasClass('menu_open')) {
        menu.removeClass('menu_open')
      }
    })

    startSlide();
});